import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "hash",
  routes: [
    { path: "/login", name: "登录", component: () => import("./views/Login") },
    { path: "/register", name: "注册", component: () => import("./views/Register") },
    {
      path: '/',
      component: () => import("./views/Nav"),
      children: [
        { path: "/", alias: '/index', component: () => import("./views/home/Home.vue"), name: "主页", meta: { requireAuth: true } },
        { name: '招聘服务', path: '/serve', component: () => import('./views/home/Serve') },
        { path: '/schoolDetail', component: () => import('./views/home/SchoolDetail.vue'), meta: { item1: '首页', item2: '学校详情页' } },
        { path: "/pay", component: () => import("./views/pay"), name: "付费" },
        // 账号管理
        { path: '/username', component: () => import('./views/account/username/username'), meta: { item1: '账号管理', item2: '账号信息' } },
        { path: '/password', component: () => import('./views/account/password/password'), meta: { item1: '账号管理', item2: '修改密码' } },
        { path: "/myInfo", component: () => import("./views/myInfo"), meta: { requireAuth: true } },
        { path: '/apply', component: () => import('./views/cooperation/apply.vue'), meta: { item1: '学校合作管理', item2: '合作学校申请' } },
        { name: "校企合作申请", path: "/applyList", component: () => import("./views/cooperation/applyList"), meta: { requireAuth: true } },
        { name: "平台推荐学校", path: "/schoolList", component: () => import("./views/cooperation/schoolList"), meta: { requireAuth: true } },
        { name: "申请合作学校", path: "/addSchool", component: () => import("./views/cooperation/addSchool"), meta: { requireAuth: true } },
        { name: "新增校企合作申请", path: "/applyAdd", component: () => import("./views/cooperation/applyAdd"), meta: { requireAuth: true } },
        { name: "合作意向", path: "/cooperationIntention", component: () => import("./views/cooperation/cooperationIntention"), meta: { requireAuth: true } },
        // { name: "岗位发布列表", path: "/jobList", component: () => import("./views/job/jobList"), meta: { requireAuth: true } },
        { name: "学校岗位发布列表", path: "/schoolJobList", component: () => import("./views/schoolJob/jobList"), meta: { requireAuth: true } },
        { name: "平台岗位发布列表", path: "/platformJobList", component: () => import("./views/platformJob/jobList"), meta: { requireAuth: true } },
        // { name: "岗位发布", path: "/jobAdd", component: () => import("./views/job/jobAdd"), meta: { requireAuth: true } },
        { name: "学校岗位发布", path: "/addSchoolJob", component: () => import("./views/schoolJob/addSchoolJob"), meta: { requireAuth: true } },
        { name: "学校双选会岗位发布", path: "/addDouSchoolJob", component: () => import("./views/schoolJob/addDouSchoolJob"), meta: { requireAuth: true } },
        { name: "平台岗位发布", path: "/addPlatformJob", component: () => import("./views/platformJob/addPlatformJob"), meta: { requireAuth: true } },
        { name: "学校岗位投递", path: "/schoolResume", component: () => import("./views/schoolJob/resumeList"), meta: { requireAuth: true } },
        { name: "平台岗位投递", path: "/platformResume", component: () => import("./views/platformJob/resumeList"), meta: { requireAuth: true } },
        // { path: '/chooseChannel', component: () => import('./views/job/ChooseChannel'), meta: { item1: '岗位管理', item2: '发布渠道', } },
        { name: "简历管理列表", path: "/resumeList", component: () => import("./views/job/resumeList"), meta: { requireAuth: true } },
        { name: '发布签到页岗位', path: '/add-job-to-sign', component: () => import('./views/job/job-to-sign/addSignJob.vue'), meta: { item1: '岗位管理', item2: '发布签到页岗位' } },
        // { name: '发布签到页岗位', path: '/add-job-to-sign', component: () => import('./views/job/job-to-sign/add.vue'), meta: { item1: '岗位管理', item2: '发布签到页岗位' } },
        {
          name: '签到页岗位',
          path: '/sign-job-list',
          component: () => import('./views/job/job-to-sign/list.vue'),
          meta: { item1: '岗位管理', item2: '签到页岗位' }
        },
        {
          name: '推荐岗位投递',
          path: '/findResumeList',
          component: () => import('./views/job/job-to-sign/findResumeList.vue'),
        },
        {
          name: '学校发布的岗位收到的简历',
          path: '/resume-from-school-job',
          component: () => import('./views/resume/resume-from-school-job')
        },
        {
          name: '企业发布的岗位收到的简历',
          path: '/resume-from-enterprise-job',
          component: () => import('./views/resume/resume-from-enterprise-job')
        },
        {
          path: '/resume',
          component: () => import('./views/resume/resume')
        },
        {
          path: '/job-fair-resume',
          component: () => import('./views/job-fair/Resume')
        }

      ]
    },
    // H5企业注册
    { name: "手机号注册", path: "/mobRegister/:school_id/:id", component: () => import("./views/webview/mobRegister"), },
    { name: "测试", path: "/test/test", component: () => import("./views/webview/test"), },
    { name: "测试", path: "/test/test2", component: () => import("./views/webview/test2"), },
    { name: "企业信息", path: "/share/:school_id/:id", component: () => import("./views/webview/share"), },
    { name: "营业执照", path: "/upload/:school_id/:id", component: () => import("./views/webview/upload") },
    { name: '发布岗位', path: "/job", component: () => import("./views/webview/job") },
    { name: "注册成功", path: "/success", component: () => import("./views/webview/success"), },
    { name: '协议', path: '/agreement', component: () => import('./views/webview/agreement.vue') },
    { name: "H5付费", path: "/enterprise-pay-h5", component: () => import("./views/webview/pay"), },
    { name: "H5付费-多人邀请", path: "/enterprise-pay-h5-repeat", component: () => import("./views/webview/pay2"), },
    // 短信通知，付费页面
    { path: "/a", component: () => import("./views/webview/a") },
    // 电脑端付费成功页面
    { path: '/pay-success', component: () => import('./views/pay/pay-success') },
    { path: '/pay-pc', component: () => import('./views/pay/pay-pc.vue') },
    // 手机端页面
    // {
    //   path: "/mobile", component: () => import("./views/mobile/index.vue"),
    // },
    // {
    //   path: "/mobile/add-job", component: () => import("./views/mobile/addJob.vue"), name: "发布岗位"
    // }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
